import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/Print.css';
import OurProductsSection from "./OurProductsSection"

import print1 from '../assets/print1.jpg'
import print2 from '../assets/print2.jpg'
import print3 from '../assets/print3.jpg'
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

import Printpdf from '../assets/dummy.pdf'
import printImg from '../assets/solution-printImg.jpg';


const Print = () => {
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="Print">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner10">
        <div className="hero-content">
          <h1>Print</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Print</span>
          </div>
        </div>
      </section> */}

<section className="Print-hero-clean">
  <div className="hero-text">
    <h1>Printing</h1>
    <p>
We enable precise print mark detection, web guiding, and registration control with high-performance sensors designed for dynamic print and packaging lines.
</p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={printImg} alt="Print Industry" />
  </div>
</section>


<section className="print-content">
  {[
    {
      title: "Double-sheet detection of printing papers",
      text: "Adjust the speed by the beat rate of the pressing or stamping process. The distance between the plate and the sensor is used as a signal to control the speed of the motor.",
      img: print1
    },
    {
      title: "Detect the discharge of printed paper or textilecloth",
      text: "Detect the discharge of printed paper or textile cloth.",
      img: print2
    },
    {
      title: "Correct the position of the cylinder of the tire printing machine",
      text: "Realize display accuracy error and correct deviation.",
      img: print3
    }
  ].map((item, idx) => (
    <div className={`print-row ${idx % 2 !== 0 ? 'reverse' : ''}`} key={idx}>
      <div className="print-image">
        <img src={item.img} alt={item.title} />
      </div>
      <div className="print-text">
        <h3>{item.title}</h3>
        <p>{item.text}</p>
      </div>
    </div>
  ))}
</section>


<OurProductsSection />
      <section className="action-buttons-section">
        <a href={Printpdf} target="_blank" rel="noopener noreferrer">
          <button className="download-btn">📄 Download</button>
        </a>
          <button className="quote-btn" onClick={() => setIsModalOpen(true)}>📩 Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      </section>

      <Footer />
    </div>
  );
};
export default Print;